<template>
  <!--
    Example Data
    { name: "no_input", input_type: "no_input"}
  -->
  <v-row>
  </v-row>
</template>

<script>

export default {
  name: 'no-input-field',
  inputType: 'no_input',
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {}
  }
}
</script>
